const config = {
  COUNTRY_URL: "https://countriesnow.space/api/v0.1/countries",
  BASE_URL: "https://api.clientl.app/api",
  SERVER_BASE_URL: "https://api.clientl.app",
  CLIENT_BASE_URL: "https://my.clientl.app",
  SUPPORT_TEAM_EMAIL_ADDRESS: 'team@clientl.app',
  // BASE_URL: "http://localhost:3003/api",
  // SERVER_BASE_URL: "http://localhost:3003",
  // CLIENT_BASE_URL: "http://localhost:3000",
  // SUPPORT_TEAM_EMAIL_ADDRESS: 'coalabear1010@gmail.com',
};

export default config;